import { FunctionComponent } from "react";
import DcSelectField from "../../../../../ui/new_components/entity_selects/DcSelectField";

interface JobWorkFieldsProps {
  editable: boolean;
  readOnly: boolean;
  lineType?: string;
  dcReferenceId?: string;
  onLineTypeChange: (v: string) => void;
  onDcSelect: (dc: { id: string }) => void;
}

/** Job Work-only line fields: Type, Payable / Inventory-Impact badges, DC search. */
const JobWorkFields: FunctionComponent<JobWorkFieldsProps> = ({
  editable,
  readOnly,
  lineType,
  dcReferenceId,
  onLineTypeChange,
  onDcSelect,
}) => {
  const isService = lineType === "service";
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2 flex-wrap">
        <select
          disabled={!editable}
          value={lineType ?? ""}
          onChange={(e) => onLineTypeChange(e.target.value)}
          className="border rounded-md px-2 py-1 text-xs bg-white"
        >
          <option value="">Select</option>
          <option value="service">Service Line</option>
          <option value="inventory">Inventory (FG/SFG)</option>
        </select>
        {isService ? (
          <>
            <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-700">
              PAYABLE
            </span>
            <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-gray-100 text-gray-600">
              NO INVENTORY IMPACT
            </span>
          </>
        ) : (
          <>
            <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-gray-100 text-gray-600">
              NON-PAYABLE
            </span>
            <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-700">
              INVENTORY IMPACT
            </span>
          </>
        )}
      </div>
      <p className="text-xs italic text-gray-500">
        {isService
          ? "This service line is payable and subject to GST."
          : "Used only for inventory valuation. Not payable. GST not applicable."}
      </p>
      <div>
        <span className="text-gray-400 block mb-1">
          Job Work Preferences (DC)
        </span>
        <DcSelectField
          disabled={!editable || readOnly}
          value={dcReferenceId ?? ""}
          onSelect={onDcSelect}
        />
      </div>
    </div>
  );
};

export default JobWorkFields;
